import {bankingConstants} from '../constants';
import {cardsHelpers} from '../../utils/helpers';

const defaultVerification = {
  isCreatedUser: false,
  isRequired: false,
  isChecked: false,
  status: null, // light_none, light_pending, light_validated, light_refused
}

const cardState = {
  cardDetails: null,
  cards: [],
  users: [],
  companyDetails: null,
  companyState: null,
  isEnabledBanking: false,
  invitedUser: null,
  legalPerson: undefined,
  verification: defaultVerification
};

const bankingReducer = (state = cardState, action) => {
  const {type, data} = action;
  switch (type) {
    case bankingConstants.CLEAR_CARDS:
      return {
        ...state,
        cards: [],
        users: []
      }
    case bankingConstants.GET_CARD_LIST:
    case bankingConstants.GET_USER_CARD_LIST:
      return {
        ...state,
        cards: data
      }
    case bankingConstants.GET_CARD_USERS:
      return {
        ...state,
        users: data
      }
    case bankingConstants.GET_USER_CARD_DETAILS:
      return {
        ...state,
        cardDetails: data
      }
    case bankingConstants.SET_VERIFICATION_STATUS:
      return {
        ...state,
        verification: {
          ...state.verification,
          ...action.verification,
          isChecked: true
        }
      }
    case bankingConstants.CREATE_USER:
      return {
        ...state,
        isCreatedUser: true
      }
    case bankingConstants.GET_COMPANY_STATE:
      return {
        ...state,
        companyState: data,
        isEnabledBanking: cardsHelpers.checkIsAvailableBanking(data)
      }
    case bankingConstants.GET_COMPANY_DETAILS:
      return {
        ...state,
        companyDetails: data
      }
    case bankingConstants.CLEAR_CARDS_DATA:
      return {
        ...state,
        cards: [],
        companyState: null,
        companyDetails: null,
        isEnabledBanking: false,
        invitedUser: null,
        legalPerson: undefined,
        verification: defaultVerification,
        users: []
      }
    case bankingConstants.CLEAR_CARD_DETAILS:
      return {
        ...state,
        cardDetails: null
      }
    case bankingConstants.SET_INVITED_USER:
      return {
        ...state,
        invitedUser: data
      }
    case bankingConstants.SET_LEGAL_PERSON_DETAILS:
      return {
        ...state,
        legalPerson: data.user
      }
    default:
      return state;
  }
};

export default bankingReducer;
